import { Grid, Typography } from '@material-ui/core'
import moment from 'moment'
import { FC } from 'react'
import { useForm } from 'react-final-form'
import useTranslate from '../../i18n/useTranslate'
import DatePicker from './datepicker'

const DateRangePicker: FC<{
    names: {
        start: string
        end: string
    }
    label: string
    minDates?: {
        start?: Date
        end?: Date
    }
    maxDates?: {
        start?: Date
        end?: Date
    }
}> = ({ names, label, minDates, maxDates }) => {
    const form = useForm()
    const translate = useTranslate()

    const handleChangeStart = () => {
        const formVal = form.getState().values
        const startDate = moment(formVal[names.start])
        const endDate = moment(formVal[names.end])
        if (startDate > endDate) {
            startMoreThanEnd()
        }
        if (formVal[names.start] && !formVal[names.end]) {
            form.getFieldState(names.end)?.change(formVal[names.start])
        }
    }

    const handleChangeEnd = () => {
        const formVal = form.getState().values
        const startDate = moment(formVal[names.start])
        const endDate = moment(formVal[names.end])
        if (endDate < startDate) {
            endLessThanStart()
        }
        if (formVal[names.end] && !formVal[names.start]) {
            form.getFieldState(names.start)?.change(formVal[names.end])
        }
    }

    const startMoreThanEnd = () => {
        form.getFieldState(names.end)?.change(form.getFieldState(names.start)?.value)
    }

    const endLessThanStart = () => {
        form.getFieldState(names.start)?.change(form.getFieldState(names.end)?.value)
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="body2">{label}</Typography>
            </Grid>
            <Grid
                item
                style={{
                    width: 'calc(50% - 22px)',
                }}
            >
                <DatePicker
                    name={names.start}
                    clearable={false}
                    onChangeValue={handleChangeStart}
                    minDate={minDates?.start}
                    maxDate={maxDates?.start}
                />
            </Grid>
            <Grid item style={{ paddingTop: '28px' }}>
                <Typography variant="body2">&nbsp;&nbsp;{translate.get('LABEL.END_DATE')}&nbsp;&nbsp;</Typography>
            </Grid>
            <Grid
                item
                style={{
                    width: 'calc(50% - 22px)',
                }}
            >
                <DatePicker
                    name={names.end}
                    clearable={false}
                    onChangeValue={handleChangeEnd}
                    minDate={minDates?.end}
                    maxDate={maxDates?.end}
                />
            </Grid>
        </Grid>
    )
}

export default DateRangePicker
